import React from 'react';
import { Button } from 'primereact/button';
import CreateNewUser from '../user-management/CreateNewUser';
import EditUser from '../user-management/EditEmployees';
import ManagedTableCard from '../../../../components/ui/ManagedTableCard';

const renderCreateForm = (onDone) => <CreateNewUser onCloseDialog={onDone} />;
const renderEditForm = (row, onDone) => <EditUser employeeData={row} onCloseDialog={onDone} />;
const renderExtraActions = () => <Button text raised size="small" icon="pi pi-times" className="btn btn-error btn-sm  p-button-danger" />;

// Admin table with a "Create new" dialog and a per-row edit button.
// Shared by the banking-details and beneficiaries pages, which differ only in title, columns and rows.
const RecordsTable = ({ title, exportName, columns, rows }) => (
  <ManagedTableCard
    title={title}
    exportName={exportName}
    columns={columns}
    rows={rows}
    emptyMessage="No records found"
    createLabel="Create new"
    createIcon="pi pi-user-plus"
    createHeader="Register new user"
    editHeader="Edit user"
    successMessage="User registered successfully"
    renderCreateForm={renderCreateForm}
    renderEditForm={renderEditForm}
    extraRowActions={renderExtraActions}
  />
);

export default RecordsTable;
